// Libs
import { ButtonProps } from 'ui-components';
import React, { ReactElement, RefObject } from 'react';
import clsx from 'clsx';
// App
import { Button } from 'ui-components';
import styles from './action-button.module.scss';

const ActionButton = React.forwardRef(
  (props: ButtonProps, ref: RefObject<HTMLButtonElement>): ReactElement => {
    return (
      <Button
        role="button"
        color="primary"
        size="medium"
        variant="contained"
        type="button"
        {...props}
        className={clsx(styles.button, props.className)}
        ref={ref}
      >
        {props.children}
      </Button>
    );
  }
);

export default ActionButton;
